"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var http_1 = require("@angular/common/http");
var captcha_service_1 = require("../../Services/captcha.service");
var adv_edit_component_1 = require("../adv-edit/adv-edit.component");
var AdvManageComponent = /** @class */ (function () {
    function AdvManageComponent(captchaService, HttpClient, fb, services, route) {
        this.captchaService = captchaService;
        this.HttpClient = HttpClient;
        this.fb = fb;
        this.services = services;
        this.route = route;
        this._advLoaded = false;
    }
    Object.defineProperty(AdvManageComponent.prototype, "advLoaded", {
        get: function () {
            return this._advLoaded;
        },
        set: function (value) {
            this._advLoaded = value;
        },
        enumerable: true,
        configurable: true
    });
    AdvManageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var manageId = this.route.snapshot.paramMap.get("manage-id");
        if (manageId == null || "" == manageId.trim()) {
            this.services.route.navigate([""]);
        }
        else {
            this.services.advService.getByManageId(manageId).then(function (result) {
                _this.advLoaded = true;
                if (result.adveristments && result.adveristments.length == 1) {
                    _this.advEdit.bindAdvertisement(result.adveristments[0], manageId);
                }
            }).catch(function (res) {
                _this.services.showError(res);
                _this.services.route.navigate([""]);
            });
        }
    };
    AdvManageComponent.prototype.ngOnInit = function () {
    };
    return AdvManageComponent;
}());
exports.AdvManageComponent = AdvManageComponent;
